import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Form, Field } from 'redux-form'
import Button from 'components/common/Button/Button'
import { Separator } from 'components/common/Separator/Separator'
import { Emails, Passwords, KeepInContact, TermsAgreement, Name, CellPhoneNumber } from '../fields'
import ReCaptcha from '../ReCaptcha'
import { KEEP_IN_CONTACT_LABEL } from 'constant/index.js'

const CreateAccountForm = ({
  form,
  error,
  captchaRef,
  rules,
  values,
  maxLength,
  emailNote,
  keepInContactInstructions,
  termsPagePath,
  isSubmitting,
  handleSubmit,
  handleCustomSubmit,
  showReCaptcha,
  BOTGoogleReCaptchaSiteKey,
  reCaptchaOnChange,
  notVerifiedReCaptchaMessage,
  reCaptchaOnExpired,
  ...props
}) =>
  <Form data-at-create-account-form onSubmit={ handleSubmit(handleCustomSubmit) }>
    <Name { ...props } form={ form.firstName } />
    <Name { ...props } form={ form.lastName } />
    <CellPhoneNumber { ...props } form={ form } />
    <Emails { ...props } notes={ emailNote } form={ form } />
    <Passwords { ...props } form={ form } rules={ rules } values={ values } maxLength={ maxLength } />
    <KeepInContact
      { ...props }
      form={ form }
      label={ KEEP_IN_CONTACT_LABEL } />
    <Separator margin="23px 0 28px" />
    <TermsAgreement { ...props } form={ form } path={ termsPagePath } />

    {showReCaptcha && (
      <ReCaptcha
        captchaRef={ captchaRef }
        BOTGoogleReCaptchaSiteKey={ BOTGoogleReCaptchaSiteKey }
        reCaptchaOnChange={ reCaptchaOnChange }
        notVerifiedReCaptchaMessage={ notVerifiedReCaptchaMessage }
        reCaptchaOnExpired={ reCaptchaOnExpired } />
    )}

    <CreateAccountButton narrow data-at-create-account-button full="mobile">
      CREATE ACCOUNT
    </CreateAccountButton>
    <Field { ...form.hiddenField } component="input" />
  </Form>

CreateAccountForm.propTypes = {
  BOTGoogleReCaptchaSiteKey: PropTypes.string,
  captchaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Component) })
  ]),
  emailNote: PropTypes.string,
  error: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.array]
  ),
  form: PropTypes.shape({
    hiddenField: PropTypes.shape(),
    termsAgreement: PropTypes.shape({
      name: PropTypes.string
    }),
    firstName: PropTypes.shape(),
    lastName: PropTypes.shape()
  }),
  handleCustomSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  keepInContactInstructions: PropTypes.string,
  maxLength: PropTypes.number,
  notVerifiedReCaptchaMessage: PropTypes.string,
  reCaptchaOnChange: PropTypes.func,
  reCaptchaOnExpired: PropTypes.func,
  rules: PropTypes.arrayOf(PropTypes.shape()),
  showReCaptcha: PropTypes.bool,
  termsDisplayName: PropTypes.string,
  termsPagePath: PropTypes.string,
  values: PropTypes.shape()
}

export default CreateAccountForm

const CreateAccountButton = styled(Button)`
  margin-top: 10px;
`
